<template>
    <b-modal id="sportsmanModal" ref="sportsmanModal" hide-footer hide-header no-close-on-backdrop>
        <div class="modal-user-login">
            <template>
                <button type="button" class="close" data-dismiss="modal" @click="hideModal()">
                    &times;
                </button>
                <p class="font-weight-bold">Riepilogo</p>
                <div class="reservation__address">
                    <img class="m-r-5" src="/images/address_info_marker.svg" />
                    {{ course.address }}s
                    <br>
                    <div v-if="selectedlesson">
                        {{selectedlesson.long_day}} {{selectedlesson.date}} {{selectedlesson.month}} | {{ selectedlesson.start_time ? 'dalle ' + selectedlesson.start_time + ' alle ' + selectedlesson.end_time : 'dalle ' + selectedlesson.time }}
                    </div>

                </div>
            </template>
            <hr>
            <b-form @submit.prevent="confirmSportsman" data-vv-scope="sportsman-form">
                <!--<b-form-group>
                    <b-form-select :disabled="!friends || friends.length < 1"
                                   v-model="selectedFriend"
                                   value-field="id"
                                   v-show="friends && friends.length >= 1"
                                   text-field="name"
                                   :options="friends"
                                   class="form-input"/>
                </b-form-group>-->

                <b-form-group>
                    <p class="font-weight-bold mb-1">Concludi la tua prenotazione</p>

                    <b-form-input type="email"
                                  v-model="sportsman.email"
                                  placeholder="Email"
                                  class="form-input">
                    </b-form-input>
                </b-form-group>

                <b-form-group>
                    <p class="font-weight-bold mb-1 mt-4">Chi sarà lo sportivo?</p>

                    <b-form-input type="text"
                                  v-model="sportsman.firstName"
                                  placeholder="Nome"
                                  class="form-input">
                    </b-form-input>
                </b-form-group>
                <b-form-input type="text"
                              v-model="sportsman.lastName"
                              placeholder="Cognome"
                              class="form-input">
                </b-form-input>
                <p class="font-weight-bold mb-1 mt-4">Data di nascita</p>
                <div class="d-flex justify-content-between mb-2">
                    <div class="flex-fill mr-2">
                        <b-form-group>
                            <b-form-select v-model="sportsman.birthday.day"
                                           :options="days"
                                           class="form-input"/>
                        </b-form-group>
                    </div>
                    <div class="flex-fill mx-2">
                        <b-form-group>
                            <b-form-select v-model="sportsman.birthday.month"
                                           :options="months"
                                           class="form-input"/>
                        </b-form-group>
                    </div>
                    <div class="flex-fill ml-2">
                        <b-form-group>
                            <b-form-select v-model="sportsman.birthday.year"
                                           :options="years"
                                           class="form-input"/>
                        </b-form-group>
                    </div>
                </div>
                <b-form-group>
                    <b-form-checkbox v-model="accept_promotion"><p class="font-12">Se desideri non ricevere promozioni e comunicazioni da OrangoGo, spunta questa casella</p></b-form-checkbox>
                </b-form-group>
                <b-form-group>
                    <b-btn class="btn-primary font-28 text-uppercase" variant="default"
                           block type="submit">Prenota</b-btn>
                </b-form-group>
                <p class="font-12">Cliccando su "Prenota" accetti <a target="_blank" rel="noopener noreferrer" href="/terms">Termini e Condizioni d'uso</a>, <a target="_blank" rel="noopener noreferrer" href="/condizioni-generali">condizioni generali</a> con utenti e l'<a target="_blank" rel="noopener noreferrer" href="/privacy">informativa sulla privacy</a> e Cookie.</p>
            </b-form>
        </div>
    </b-modal>
</template>

<script>
    import ReservationAddress from './ReservationAddress';
    import ReservationLessonDropdown from './ReservationLessonDropdown';

    export default {
        name: "ReservationSportsman",
        props:['reservationId', 'course', 'selecteddate', 'selectedlesson'],
        components: {
            ReservationAddress,
            ReservationLessonDropdown
        },
        data () {
            return {
                accept_promotion: false,
                friends: [],
                days: [
                    {value: undefined, text: 'Giorno'}
                ],
                months: [
                    {value: undefined, text: 'Mese'},
                    {value: 0, text: 'Gennaio'},
                    {value: 1, text: 'Febbraio'},
                    {value: 2, text: 'Marzo'},
                    {value: 3, text: 'Aprile'},
                    {value: 4, text: 'Maggio'},
                    {value: 5, text: 'Giugno'},
                    {value: 6, text: 'Luglio'},
                    {value: 7, text: 'Agosto'},
                    {value: 8, text: 'Settembre'},
                    {value: 9, text: 'Ottobre'},
                    {value: 10, text: 'Novembre'},
                    {value: 11, text: 'Dicembre'}
                ],
                years: [
                    {value: undefined, text: 'Anno'}
                ],
                selectedFriend: undefined,
                sportsman: {
                    firstName: null,
                    lastName: null,
                    birthday: {
                        day: undefined,
                        month: undefined,
                        year: undefined
                    },
                    email: null
                },
            }
        },
        created () {
            for (let i = 1; i <= 31; i++) {
                this.days.push({value: i, text: i});
            }
            for (let i = new Date().getFullYear(); i >= 1928; i--) {
                this.years.push({value: i, text: i});
            }
        },
        mounted () {
            this.getFriends();
        },
        watch: {
            selectedFriend () {
                if (this.selectedFriend !== undefined) {
                    let friend = this.friends.find((friend) => {
                        return friend.id == this.selectedFriend;
                    });
                    let birthday = new Date(friend.birthday);
                    let day = birthday.getDate();
                    let month = birthday.getMonth();
                    let year = birthday.getFullYear();

                    this.sportsman = {
                        firstName: friend.first_name,
                        lastName: friend.last_name,
                        birthday: {
                            day: day,
                            month: this.months.find((singleMonth) => singleMonth.value == month).value,
                            year: year,
                        },
                        email: friend.email
                    };
                }
                else {
                    this.sportsman = {
                        firstName: null,
                        lastName: null,
                        birthday: {
                            day: undefined,
                            month: undefined,
                            year: undefined
                        },
                        email: null
                    };
                }
            },
        },
        methods: {
            selectLesson(lesson) {
                this.selected = lesson;
                this.selected.course_day_id = lesson.id;
            },
            getFriends () {
                axios({
                    method: 'get',
                    url: '/friends'
                }).then((response) => {
                    if (response.data.friends.length > 0) {
                        this.friends = [{'id': undefined, 'name': 'Scegli chi praticherà'}];
                        response.data.friends.forEach((friend) => {
                            friend.name = friend.first_name + ' ' + friend.last_name;
                            this.friends.push(friend);
                        });
                    }
                    else {
                        //this.friends = [{'id': undefined, 'name': 'No saved sportsmen', disabled: true}];
                    }
                }).catch((error) => {
                    this.message = 'Error';
                });
            },
            hideModal() {
                $('#sportsmanModal').modal('hide');
            },
            confirmSportsman () {
                axios({
                    method: 'post',
                    url: '/reservations',
                    data: {
                        reservation: this.selecteddate,
                        sportsman: this.sportsman,
                        accept_promotion: this.accept_promotion
                    }
                }).then((response) => {
                    this.$store.dispatch('setReservationState', null);
                    window.location.href = '/reservations/' + response.data.reservation.id + '/confirm';
                }).catch((error) => {
                    window.alerts.error('Could not create reservation');
                });
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/reservation/ReservationSportsman.vue